/**
 * Loot pool entries configuration
 *
 * This file is auto-generated by the balance importer.
 * Do not edit manually - changes will be overwritten.
 *
 * Generated at: 2025-09-25T12:43:18.994Z
 */

import { ConfigType } from './ConfigType';

export interface LootPoolEntryConfig {
  loot_pool_id: string;
  item_id: string;
  weight: number;
  qty_min: number;
  qty_max: number;
  notes: string | null;
  configType: ConfigType.LOOT_POOL_ENTRIES;
}

export const lootPoolEntriesData: LootPoolEntryConfig[] = [
  {
    loot_pool_id: 'LP_COMMON',
    item_id: 'ore_stone',
    weight: 55,
    qty_min: 1,
    qty_max: 2,
    notes: null,
    configType: ConfigType.LOOT_POOL_ENTRIES,
  },
  {
    loot_pool_id: 'LP_COMMON',
    item_id: 'ore_crystal',
    weight: 25,
    qty_min: 1,
    qty_max: 3,
    notes: null,
    configType: ConfigType.LOOT_POOL_ENTRIES,
  },
  {
    loot_pool_id: 'LP_QUARTZ',
    item_id: 'itm_quartz_ore',
    weight: 70,
    qty_min: 1,
    qty_max: 2,
    notes: 'сырьё для FluxGlass',
    configType: ConfigType.LOOT_POOL_ENTRIES,
  },
  {
    loot_pool_id: 'LP_QUARTZ',
    item_id: 'itm_flux_shard',
    weight: 20,
    qty_min: 1,
    qty_max: 2,
    notes: null,
    configType: ConfigType.LOOT_POOL_ENTRIES,
  },
  {
    loot_pool_id: 'LP_QUARTZ',
    item_id: 'itm_credit_chip',
    weight: 10,
    qty_min: 4,
    qty_max: 8,
    notes: null,
    configType: ConfigType.LOOT_POOL_ENTRIES,
  },
  {
    loot_pool_id: 'LP_FERRO',
    item_id: 'itm_ferrospark_ore',
    weight: 75,
    qty_min: 1,
    qty_max: 2,
    notes: 'сырьё для NeonSteel',
    configType: ConfigType.LOOT_POOL_ENTRIES,
  },
  {
    loot_pool_id: 'LP_FERRO',
    item_id: 'itm_scrap_metal',
    weight: 15,
    qty_min: 1,
    qty_max: 2,
    notes: null,
    configType: ConfigType.LOOT_POOL_ENTRIES,
  },
  {
    loot_pool_id: 'LP_FERRO',
    item_id: 'itm_credit_chip',
    weight: 10,
    qty_min: 4,
    qty_max: 8,
    notes: null,
    configType: ConfigType.LOOT_POOL_ENTRIES,
  },
  {
    loot_pool_id: 'LP_LUMEN',
    item_id: 'itm_lumenite_crystal',
    weight: 70,
    qty_min: 1,
    qty_max: 2,
    notes: null,
    configType: ConfigType.LOOT_POOL_ENTRIES,
  },
  {
    loot_pool_id: 'LP_LUMEN',
    item_id: 'itm_quartz_ore',
    weight: 20,
    qty_min: 1,
    qty_max: 1,
    notes: null,
    configType: ConfigType.LOOT_POOL_ENTRIES,
  },
  {
    loot_pool_id: 'LP_LUMEN',
    item_id: 'itm_neon_dust',
    weight: 10,
    qty_min: 2,
    qty_max: 4,
    notes: null,
    configType: ConfigType.LOOT_POOL_ENTRIES,
  },
  {
    loot_pool_id: 'LP_VEIN',
    item_id: 'itm_neon_vein_shard',
    weight: 60,
    qty_min: 1,
    qty_max: 1,
    notes: 'ключ к статуям/монументам',
    configType: ConfigType.LOOT_POOL_ENTRIES,
  },
  {
    loot_pool_id: 'LP_VEIN',
    item_id: 'itm_ferrospark_ore',
    weight: 20,
    qty_min: 1,
    qty_max: 2,
    notes: null,
    configType: ConfigType.LOOT_POOL_ENTRIES,
  },
  {
    loot_pool_id: 'LP_VEIN',
    item_id: 'itm_lumenite_crystal',
    weight: 20,
    qty_min: 1,
    qty_max: 2,
    notes: null,
    configType: ConfigType.LOOT_POOL_ENTRIES,
  },
  {
    loot_pool_id: 'LP_SHARDS',
    item_id: 'itm_neon_dust',
    weight: 80,
    qty_min: 1,
    qty_max: 2,
    notes: null,
    configType: ConfigType.LOOT_POOL_ENTRIES,
  },
  {
    loot_pool_id: 'LP_SHARDS',
    item_id: 'itm_flux_shard',
    weight: 20,
    qty_min: 1,
    qty_max: 1,
    notes: null,
    configType: ConfigType.LOOT_POOL_ENTRIES,
  },
];

/**
 * Get all LootPoolEntryConfig entries
 */
export function getAllLootPoolEntries(): LootPoolEntryConfig[] {
  return lootPoolEntriesData;
}
